module.exports = __webpack_public_path__ + "img/ts-galaxy-logo-icon.aa99aa72.png";